import React, { Component } from 'react';
import { Input,Label,FormGroup,FormText } from 'reactstrap';
import { SketchPicker } from 'react-color';

const DEFAULT_BRAND_COLOR = '#D2E7F9';

class ColorInput extends Component {
  constructor(){
    super();

    this.state = {
      open:false,
      value:''
    };
  }

  componentWillMount(){
    if(this.props.defaultValue){
      this.setState({value:this.props.defaultValue});
    }
  }

  handleFocus(){
    if(!this.state.value){
      this.props.onChange(DEFAULT_BRAND_COLOR);
    }

    this.setState({
      open:true,
      value:this.state.value ? this.state.value : DEFAULT_BRAND_COLOR
    });
  }

  handleBlur(event){
    event.preventDefault();
    this.setState({open:false});
  }

  handleChange(color,event){
    this.setState({value:color.hex});
    this.props.onChange(color.hex);
  }

  render(){
    const { value, open } = this.state;

    const { warning } = this.props;

    return (
      <div style={{position:'relative'}}>
        <FormGroup>
          {this.props.label && (
            <Label>{this.props.label}</Label>
          )}
          <Input
            type='text'
            name={this.props.name}
            placeholder={this.props.placeholder}
            value={value}
            defaultValue={this.props.defaultValue}
            onFocus={this.handleFocus.bind(this)}
            readOnly
            style={{
              backgroundColor:'#fff'
            }}
            // onBlur={this.handleBlur.bind(this)}
          />
          {value && value.length > 0 && (
            <div 
              style={{
                position:'absolute',
                right:6,
                bottom:5,
                height:24,
                width:24,
                backgroundColor:value,
                borderRadius:'.25rem'
              }}
            />
          )}
          <div
            style={{
              position:'absolute',
              zIndex:100,
              // top:30
            }}
            hidden={!open}
          >
            {open && (
              <SketchPicker
                color={value}
                onChange={this.handleChange.bind(this)}
              />
            )}
          </div>
          <div
            style={{
              position:'fixed',
              width:'100%',
              height:'100%',
              top:0,
              left:0,
              zIndex:99
            }}
            hidden={!open}
            onClick={this.handleBlur.bind(this)}
          ></div>
          {warning.length > 0 && (
            <FormText className='DangerFeedback'>{warning}</FormText>
          )}
        </FormGroup>
      </div>
    );
  }
}

ColorInput.defaultProps = {
  onChange:() => {},
  warning:''
}


export default ColorInput;



// WEBPACK FOOTER //
// ./src/shared/components/ColorInput/ColorInput.js